import React, { memo, useMemo } from 'react';
import styled from 'styled-components';

import { Container } from '../../../components/Container';
import { CONDITION_DESKTOP } from '../../../constants/breakpoints';
import { Icon } from './Icon';
import { ModalItem } from './ModalItem';
import { ModalSubItem } from './ModalSubItem';
import { TitleBlock } from './TitleBlock';
import type { CategoryWithChildrenType } from './types';

const StyledWrapper = styled.div({
  marginTop: 60,
  marginBottom: 70,

  [CONDITION_DESKTOP]: {
    marginTop: 120,
    marginBottom: 70,
  },
});

const StyledTitle = styled.div({
  fontSize: 25,
  lineHeight: 1.2,
  fontWeight: 'bold',
  textAlign: 'center',
  color: '#111111',
  marginBottom: 20,

  [CONDITION_DESKTOP]: {
    fontSize: 40,
    lineHeight: 1.2,
  },
});

const StyledDescription = styled.div({
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 1.43,
  textAlign: 'center',
  color: '#79818c',
  marginBottom: 55,

  [CONDITION_DESKTOP]: {
    fontSize: 21,
    lineHeight: 1.67,
    marginBottom: 75,
    maxWidth: 942,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
});

const StyledContent = styled.div({
  position: 'relative',
  paddingTop: 30,
  paddingLeft: 30,
  paddingRight: 30,
  paddingBottom: 40,
  borderRadius: 12,
  boxShadow: '0 0 15px 0 rgba(0, 0, 0, 0.1)',
  border: 'solid 1px #e5e7eb',
  backgroundColor: '#ffffff',

  [CONDITION_DESKTOP]: {
    display: 'flex',
    paddingTop: 50,
    paddingLeft: 65,
    paddingRight: 35,
    paddingBottom: 60,
  },
});

const StyledItemsWrapper = styled.div({
  marginBottom: 35,

  [CONDITION_DESKTOP]: {
    marginBottom: 0,
    width: 247,
    paddingRight: 40,
  },
});

const StyledItemsSetWrapper = styled.div({
  marginBottom: 32,

  [CONDITION_DESKTOP]: {
    marginBottom: 0,
    width: 300,
    paddingRight: 40,
  },
});

const StyledItemsSetTitle = styled.div({
  fontSize: 18,
  fontWeight: 'bold',
  lineHeight: 1.11,
  color: '#8b33ff',
  marginBottom: 16,
});

const Image = styled.div({
  height: 150,
  width: '100%',
  marginBottom: 75,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundImage: 'url(/landing/banners/themes/icons-separate.png)',

  [CONDITION_DESKTOP]: {
    backgroundImage: 'url(/landing/banners/themes/icons-separate@2x.png)',
  },
});

type ModalItemsProps = {
  title: string;
  description: string;
  contentDescription: string;
  badge: string[];
};

export const ModalItems = memo<ModalItemsProps>(({ title, description, contentDescription }) => {
  // const { context: categories } = useIsomorphic<LoadParams, CategoryWithChildrenType[]>(
  //   'expertLanding/modalItems',

  //   async ({ get }) => {
  //     const response = [];

  //     return response;
  //   },
  // );

  const categories = [
    {
      category: { id: 1, name: 'Бизнес' },
      children: [
        {
          category: { id: 1, name: 'Начало бизнеса' },
          children: [
            { category: { id: 1, name: 'Открытие ИП' } },
            { category: { id: 2, name: 'Открытие ООО' } },
            { category: { id: 3, name: 'Стать самозанятым' } },
            { category: { id: 4, name: 'Выбор системы налогообложения' } },
            { category: { id: 5, name: 'Запуск стартапа' } },
            { category: { id: 6, name: 'Создание бизнес-плана' } },
            { category: { id: 7, name: 'Выбор франшизы' } },
            { category: { id: 8, name: 'Покупка готового бизнеса' } },
            { category: { id: 9, name: 'Привлечение инвестиций' } },
            { category: { id: 10, name: 'Получение кредита' } },
            { category: { id: 11, name: 'Краудфандинг' } },
            { category: { id: 12, name: 'Регистрация товарного знака' } },
          ],
        },
        {
          category: { id: 2, name: 'Выбор ПО и сервисов для бизнеса' },
          children: [
            { category: { id: 1, name: 'Для управления проектами ' } },
            { category: { id: 2, name: 'Программы бухгалтерского учёта' } },
            { category: { id: 3, name: 'CRM и ERP-системы' } },
            { category: { id: 4, name: 'Хостинг' } },
            { category: { id: 5, name: 'Домены' } },
            { category: { id: 6, name: 'ЭЦП' } },
            { category: { id: 7, name: 'Телефония' } },
          ],
        },
        {
          category: { id: 3, name: 'Маркетинг' },
          children: [
            { category: { id: 1, name: 'Реклама и продвижение' } },
            { category: { id: 2, name: 'PR' } },
            { category: { id: 3, name: 'Маркетинговые исследования' } },
            { category: { id: 4, name: 'Программы лояльности' } },
            { category: { id: 5, name: 'Логотип и фирменный стиль' } },
          ],
        },
        {
          category: { id: 4, name: 'Интернет-маркетинг' },
          children: [
            { category: { id: 1, name: 'Интернет-маркетинг под ключ' } },
            { category: { id: 2, name: 'SMM — продвижение в социальных сетях' } },
            { category: { id: 3, name: 'Разработка сайта' } },
            { category: { id: 4, name: 'Разработка интернет-магазина' } },
            { category: { id: 5, name: 'Разработка лендинга' } },
            { category: { id: 6, name: 'Разработка мобильного приложения' } },
            { category: { id: 7, name: 'SEО - продвижение в поисковиках' } },
            { category: { id: 8, name: 'Контекстная реклама' } },
            { category: { id: 9, name: 'Таргетированная реклама - в социальных сетях' } },
            { category: { id: 10, name: 'Онлайн-репутация' } },
            { category: { id: 11, name: 'Аналитика' } },
            { category: { id: 12, name: 'Электронная коммерция' } },
            { category: { id: 13, name: 'Контент-маркетинг' } },
            { category: { id: 14, name: 'Вход в маркетплейсы' } },
          ],
        },
        {
          category: { id: 5, name: 'Управление и развитие бизнеса' },
          children: [
            { category: { id: 1, name: 'Управление отделом продаж' } },
            { category: { id: 2, name: 'Подбор персонала' } },
            { category: { id: 3, name: 'Обучение персонала' } },
            { category: { id: 4, name: 'Управление персоналом' } },
            { category: { id: 5, name: 'Интернет-торговля' } },
            { category: { id: 6, name: 'Управление розничной торговлей' } },
            { category: { id: 7, name: 'Организация склада' } },
            { category: { id: 8, name: 'Управление логистикой и грузоперевозки' } },
            { category: { id: 9, name: 'Контроль качества' } },
            { category: { id: 10, name: 'Бизнес-консультанты и менторы' } },
            { category: { id: 11, name: 'Строительство объектов' } },
            { category: { id: 12, name: 'Поставки из Китая' } },
            { category: { id: 13, name: 'Лизинг' } },
            { category: { id: 14, name: 'Привлечение инвестиций' } },
            { category: { id: 15, name: 'Получение кредита' } },
            { category: { id: 16, name: 'Аренда офиса и недвижимости' } },
          ],
        },
        {
          category: { id: 6, name: 'Юридические вопросы' },
          children: [
            { category: { id: 1, name: 'Общая консультация' } },
            { category: { id: 2, name: 'Трудовые договора и право' } },
            { category: { id: 3, name: 'Договора с контрагентами и поставщиками' } },
            { category: { id: 4, name: 'Судебные дела' } },
            { category: { id: 5, name: 'Учредительные документы' } },
            { category: { id: 6, name: 'Участие в тендерах' } },
            { category: { id: 7, name: 'Организация тендеров' } },
            { category: { id: 8, name: 'Банкротство' } },
          ],
        },
        {
          category: { id: 7, name: 'Бухгалтерия и налоги' },
          children: [
            { category: { id: 1, name: 'Общая консультация' } },
            { category: { id: 2, name: 'Оптимизация налогооблажения' } },
            { category: { id: 3, name: 'Программы бухгалтерского учёта' } },
            { category: { id: 4, name: 'Смена системы налогооблажения' } },
            { category: { id: 5, name: 'Работа с НДС' } },
            { category: { id: 6, name: 'Оформление патентов' } },
          ],
        },
        {
          category: { id: 8, name: 'Эксперт в бизнесе' },
          children: [
            {
              category: { id: 1, name: 'Кафе и рестораны' },
              children: [
                { category: { id: 1, name: 'Кафе' } },
                { category: { id: 2, name: 'Рестораны' } },
                { category: { id: 3, name: 'Кофейни' } },
                { category: { id: 4, name: 'Караоке' } },
                { category: { id: 5, name: 'Кальянные' } },
              ],
            },
            {
              category: { id: 2, name: 'Пиццерии' },
              children: [
                { category: { id: 1, name: 'Суши-бары' } },
                { category: { id: 2, name: 'Столовые' } },
                { category: { id: 3, name: 'Кондитерские' } },
              ],
            },
            {
              category: { id: 3, name: 'Торговля' },
              children: [
                { category: { id: 1, name: 'Детские товары' } },
                { category: { id: 2, name: 'Спортивные товары' } },
                { category: { id: 3, name: 'Цветочный магазин' } },
                { category: { id: 4, name: 'Продуктовые магазины' } },
                { category: { id: 5, name: 'Молочные продукты' } },
                { category: { id: 6, name: 'Хлебобулочные изделия' } },
                { category: { id: 7, name: 'Обувные магазины' } },
                { category: { id: 8, name: 'Магазины одежды' } },
                { category: { id: 9, name: 'Островки' } },
                { category: { id: 10, name: 'Точки в переходах и метро' } },
                { category: { id: 11, name: 'Ювелирные магазины' } },
                { category: { id: 12, name: 'Антикварные магазины' } },
                { category: { id: 13, name: 'Веломагазины' } },
              ],
            },
            {
              category: { id: 4, name: 'Спорт и красота' },
              children: [
                { category: { id: 1, name: 'Фитнес-клубы' } },
                { category: { id: 2, name: 'Тренажёрные залы ' } },
                { category: { id: 3, name: 'Спортивные секции' } },
                { category: { id: 4, name: 'Йога центры' } },
                { category: { id: 5, name: 'Картинг' } },
                { category: { id: 6, name: 'Маникюр и педикюр' } },
                { category: { id: 7, name: 'Ресницы и брови' } },
                { category: { id: 8, name: 'Солярии' } },
                { category: { id: 10, name: 'Бани и сауны' } },
                { category: { id: 11, name: 'Косметология' } },
                { category: { id: 12, name: 'Салоны красоты' } },
                { category: { id: 13, name: 'Массаж' } },
                { category: { id: 14, name: 'Тату-салоны' } },
                { category: { id: 15, name: 'Барбершопы' } },
                { category: { id: 16, name: 'Парикмахерские' } },
              ],
            },
            {
              category: { id: 5, name: 'Услуги' },
              children: [
                { category: { id: 1, name: 'Уборка в доме, квартире' } },
                { category: { id: 2, name: 'Прокат техники' } },
                { category: { id: 3, name: 'Компьютерный ремонт' } },
                { category: { id: 4, name: 'Организация праздников и мероприятий' } },
                { category: { id: 5, name: 'Турагентства ' } },
                { category: { id: 6, name: 'Пластиковые окна' } },
                { category: { id: 7, name: 'Химчистики' } },
                { category: { id: 8, name: 'Парихмахерские' } },
              ],
            },
            {
              category: { id: 6, name: 'Обучение и образование' },
              children: [
                { category: { id: 1, name: 'Бизнес-школы' } },
                { category: { id: 2, name: 'Проф. образование' } },
                { category: { id: 3, name: 'Развитие детей' } },
                { category: { id: 4, name: 'Творчество и досуг' } },
                { category: { id: 5, name: 'Иностранные языки' } },
                { category: { id: 6, name: 'Обучение мастеров' } },
                { category: { id: 7, name: 'Обучение за рубежом' } },
                { category: { id: 8, name: 'Личностные тренинги' } },
                { category: { id: 9, name: 'Компьютерные курсы' } },
                { category: { id: 10, name: 'Фото, видеошколы' } },
                { category: { id: 11, name: 'Дизайнерские курсы' } },
                { category: { id: 12, name: 'Кулинарное обучение' } },
              ],
            },
            {
              category: { id: 7, name: 'Здоровье' },
              children: [
                { category: { id: 1, name: 'Стоматология' } },
                { category: { id: 2, name: 'Клиники' } },
                { category: { id: 3, name: 'Анализы' } },
                { category: { id: 4, name: 'Аптеки' } },
                { category: { id: 5, name: 'Мед. центры' } },
                { category: { id: 6, name: 'Даигностические центры' } },
                { category: { id: 7, name: 'Психологи' } },
                { category: { id: 8, name: 'Ветеринарные клиники' } },
                { category: { id: 9, name: 'Услуги на выезде' } },
              ],
            },
            {
              category: { id: 8, name: 'Автобизнес' },
              children: [
                { category: { id: 1, name: 'Автомастерские' } },
                { category: { id: 2, name: 'Мотосалоны' } },
                { category: { id: 3, name: 'Автосалоны' } },
                { category: { id: 4, name: 'Электротранспорт' } },
                { category: { id: 5, name: 'Автомойки' } },
                { category: { id: 6, name: 'Тонировка авто' } },
                { category: { id: 7, name: 'Ремонт автоэлектрики' } },
                { category: { id: 8, name: 'Тюнинг' } },
                { category: { id: 9, name: 'Детейлинг' } },
                { category: { id: 10, name: 'Шиномонтаж' } },
              ],
            },
            {
              category: { id: 9, name: 'Производство' },
              children: [
                { category: { id: 1, name: 'Пищевое производство' } },
                { category: { id: 2, name: 'Непищевое производство' } },
              ],
            },
            {
              category: { id: 10, name: 'Интернет-бизнес' },
              children: [
                { category: { id: 1, name: 'Интернет-магазин' } },
                { category: { id: 2, name: 'Онлайн-сервисы' } },
              ],
            },
            {
              category: { id: 11, name: 'Ремонт и стройка' },
              children: [
                { category: { id: 1, name: 'Стройматериалы' } },
                { category: { id: 2, name: 'Окна и двери' } },
                { category: { id: 3, name: 'Отделочные материалы' } },
                { category: { id: 4, name: 'Сантехника' } },
                { category: { id: 5, name: 'Натяжные потолки' } },
                { category: { id: 6, name: 'Теплоизоляция' } },
                { category: { id: 7, name: 'Ворота, шлагбаумы' } },
                { category: { id: 8, name: 'Фасадные материалы' } },
                { category: { id: 9, name: 'Заборы, ограждения' } },
                { category: { id: 10, name: 'Кондиционеры' } },
                { category: { id: 11, name: 'Светотехника' } },
                { category: { id: 12, name: 'Электротехника' } },
                { category: { id: 13, name: 'Инструменты на прокат' } },
                { category: { id: 14, name: 'Мебель на заказ' } },
              ],
            },
          ],
        },
      ],
    },
  ];

  const [items, rightBlockRoot] = useMemo(() => {
    if (!categories || categories.length === 0) {
      return [[], null];
    }

    const { children } = categories[0];

    if (children.length === 0) {
      return [[], null];
    }

    if (children.length === 1) {
      return [children, null];
    }

    const itemsRes: CategoryWithChildrenType[] = children.slice();
    const rightBlockRootRes: CategoryWithChildrenType | undefined = itemsRes.pop();

    return [itemsRes, rightBlockRootRes];
  }, [categories]);

  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <StyledWrapper>
      <Container>
        <Image />
        <StyledTitle>{title}</StyledTitle>
        <StyledDescription>{description}</StyledDescription>

        <StyledContent>
          {/* <StyledBadgeWrapper>
            <Badge items={badge} />
          </StyledBadgeWrapper> */}

          <TitleBlock contentTitle={categories[0].category.name} contentDescription={contentDescription} />

          <StyledItemsWrapper>
            {items.map((modalItem) => (
              <ModalItem modalItem={modalItem} key={modalItem.category.id} />
            ))}
          </StyledItemsWrapper>

          <StyledItemsSetWrapper>
            {rightBlockRoot && (
              <>
                <StyledItemsSetTitle>{rightBlockRoot.category.name}</StyledItemsSetTitle>

                <div>
                  {rightBlockRoot.children?.map((modalItem) => (
                    <ModalSubItem modalItem={modalItem} key={modalItem.category.id} />
                  ))}
                </div>
              </>
            )}
          </StyledItemsSetWrapper>

          <Icon />
        </StyledContent>
      </Container>
    </StyledWrapper>
  );
});
